import React from 'react'
import { CCol, CFormLabel, CFormSelect, CFormSwitch, CRow } from '@coreui/react-pro'
import InfoTooltip from './InfoTooltip'

const range = (length) => Array.from({ length }, (_, i) => i + 1)

const PlayerCategoryRestrictions = ({
  values,
  onChange,
  teamSize,
  externalPlayerList,
  isTeamExists,
}) => {
  const teamSizeLimitValues = range(teamSize || 1)

  return (
    <CRow className="g-3">
      <CCol md={4}>
        <div className="d-flex align-items-center">
          <CFormSwitch
            id="pcr_enabled"
            className="me-2"
            checked={values.pcr_enabled}
            onChange={(e) => onChange('pcr_enabled', e.target.checked)}
          />
          <CFormLabel className="fw-bold mb-0 d-flex align-items-center" htmlFor="pcr_enabled">
            Player Category Restriction (PCR)
            <InfoTooltip content="Limit the number of PCR tagged players (e.g. Interstate or Overseas) a member can pick." />
          </CFormLabel>
        </div>
        <small className="text-medium-emphasis">Limit the number of PCR tagged players.</small>
      </CCol>

      <CCol md={4}>
        <CFormLabel className="fw-bold d-flex align-items-center" htmlFor="pcr_term">
          PCR Term
          <InfoTooltip content="The label shown to members for this restricted player category." />
        </CFormLabel>
        <CFormSelect
          id="pcr_term"
          value={values.pcr_term}
          onChange={(e) => onChange('pcr_term', e.target.value)}
          disabled={!values.pcr_enabled}
        >
          {externalPlayerList?.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </CFormSelect>
      </CCol>

      <CCol md={4}>
        <CFormLabel className="fw-bold d-flex align-items-center" htmlFor="pcr_max_players">
          Max PCR Players
          <InfoTooltip content="The maximum number of PCR tagged players a member is allowed to pick in their team." />
        </CFormLabel>
        <CFormSelect
          id="pcr_max_players"
          value={values.pcr_max_players}
          onChange={(e) => onChange('pcr_max_players', e.target.value)}
          disabled={!values.pcr_enabled || isTeamExists}
        >
          {teamSizeLimitValues.map((number) => (
            <option key={number} value={number}>
              {number}
            </option>
          ))}
        </CFormSelect>
      </CCol>
    </CRow>
  )
}

export default PlayerCategoryRestrictions
